import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Tables from "../views/Tables.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import Logout from "../views/components/Logout.vue";
import VocabularyLearning from "../views/VocabularyLearning.vue";
import QuizHistory from "../views/QuizHistory.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/flashcard",
    name: "Flash Card",
    component: Tables,
  },
  {
    path: "/quiz",
    name: "Quiz",
    component: QuizHistory,
  },
  {
    path: "/vocabulary",
    name: "VocabularyLearning",
    component: VocabularyLearning,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});


export default router;
